import { render, staticRenderFns } from "./waterstate.vue?vue&type=template&id=2ce45865&scoped=true&"
import script from "./waterstate.vue?vue&type=script&lang=js&"
export * from "./waterstate.vue?vue&type=script&lang=js&"
import style0 from "./waterstate.vue?vue&type=style&index=0&id=2ce45865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce45865",
  null
  
)

export default component.exports